import React from 'react'
import { connect } from 'react-redux'
import CategoryActions from '../../Redux/CategoryRedux'
import FileUploader from '../FileUploader'
import FilesActions from '../../Redux/FilesRedux'

class UpdateCategory extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        name: props.detail.name || '',
        id: props.detail.id || '',
        icon_file: props.detail.icon_file || '',
        image_file: props.detail.image_file || ''
      },
      image_type: '',
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = {...this.state.form}
      form.image_file = newProps.files.data.upload[0].filename
      form.icon_file = newProps.files.data.upload[0].filename
    }
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'category')
    data.append('image_type', this.state.image_type)
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _fileUploaded = (filename, field) => {
    let form = {...this.state.form}
    form[field] = filename
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateCategory(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Category Image</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group text-center'>
            <label className='control-label'>Current Image</label>
            <img alt={this.props.detail.image_file} title={this.props.detail.image_file} className='img img-responsive img-border' style={{ width: '100%' }} src={this.props.detail.image_url} />
          </div>
          <div className='form-group text-center'>
            <label className='control-label'>Current Icon</label>
            <img alt={this.props.detail.icon_file} title={this.props.detail.icon_file} className='img img-responsive img-border' style={{ width: '100%' }} src={this.props.detail.icon_url} />
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image File(<span className='text-orange'>518x344</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'category', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image_file')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Icon File(<span className='text-orange'>100x100</span>)</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'category', image_type: 'icon' }} onUploaded={(filename) => this._fileUploaded(filename, 'icon_file')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  updateCategory: (data) => dispatch(CategoryActions.updateCategoryRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateCategory)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateCategoryImage.js